//import './stylesheets/default/spacerBar.css';
import './stylesheets/flat/SpacerBarFlat.css'
import './stylesheets/neumorphism/SpacerBarNeumorphism.css'
import './stylesheets/neobrutalism/SpacerBarNeobrutalism.css'
import './stylesheets/glassmorphism/SpacerBarGlassmorphism.css'

import InfoIcon from './InfoIcon'

function SpacerBar({style, text=""}){
    

  return (
    <div className={`spacer-bar-${style}`}>
      <InfoIcon size="50px"></InfoIcon>
      <p>{text}</p>
    </div>
  );
}

export default SpacerBar